/**
 * 사업자등록번호를 3-2-5 형식으로 자동 포맷팅
 * @param value 입력된 사업자등록번호 문자열
 * @returns 포맷팅된 사업자등록번호 문자열
 */
export const formatBusinessNumber = (value: string): string => {
  // 숫자만 추출
  const numbers = value.replace(/\D/g, '');

  // 3-2-5 형식으로 변환
  if (numbers.length <= 3) {
    return numbers;
  } else if (numbers.length <= 5) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  } else {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 5)}-${numbers.slice(5, 10)}`;
  }
};
